import { atom } from 'jotai';

import { IGetApiStudentActivityHomeEntryResponse } from '../api/interface/activity';

export const homeEntryAtom = atom<
  IGetApiStudentActivityHomeEntryResponse['content'] | null
>(null);
